import { CONNECTION_ERROR } from '../../../../configs/serverStatusCodes';

export const BLACK_WHITES_UNAVAILABLE_MESSAGE = 'Модуль недоступен';

export const isBlackWhitesModuleUnavailableStatus = status => (
  status === CONNECTION_ERROR
  || status === 404
  || status === 502
  || status === 503
  || status === 504
  || (typeof status === 'number' && status >= 500)
);

export const normalizeBlackWhitesError = (status, body = {}) => {
  if (isBlackWhitesModuleUnavailableStatus(status)) {
    return {
      message: BLACK_WHITES_UNAVAILABLE_MESSAGE,
      error: {
        message: BLACK_WHITES_UNAVAILABLE_MESSAGE,
      },
    };
  }

  if (body && typeof body === 'object') {
    return body;
  }

  return {
    message: BLACK_WHITES_UNAVAILABLE_MESSAGE,
    error: {
      message: BLACK_WHITES_UNAVAILABLE_MESSAGE,
    },
  };
};
